import { CameraIcon } from "@signet/ui";
import { defineWebModule } from "@signet/web-kit";
import { CbStatsPage } from "./page.tsx";
import "./cbstats.css";

/* The web half of CB Stats: one page, the week, with the usernames under it. */

const day = (value: unknown) => (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : undefined);

export default defineWebModule({
  id: "cbstats",
  nav: { label: "CB Stats", icon: CameraIcon, to: "/cbstats", needs: "cbstats.stats:view" },
  routes: [{ path: "/cbstats", component: CbStatsPage, needs: "cbstats.stats:view", validateSearch: (raw) => ({ week: day(raw.week) }) }],
  commands: [
    { id: "cbstats.week", label: "CB Stats", to: "/cbstats", needs: "cbstats.stats:view", hint: "Chaturbate streams this week", keywords: "chaturbate cb stats streams hours cam target slacking" },
  ],
});
